import { AEMErrorMessage } from '../../../models';

export const PartnersErrorMessage: AEMErrorMessage = {
  action: {
    label: 'View Partner Networks',
    url: '',
    id: 'viewPartnersNetworksPage'
  },
  component: 'partners',
  errorId: [
    {
      errorCode: '702'
    }
  ],
  featureTitle: '',
  errorMessageDescription:
    'Sorry, we’re currently unable to display our Partner Network. Please try again later.',
  errorMessageTitle: '',
  type: 'single-error'
};
